import { Amenity } from '../../models/amenity.model';
import { amenityColorOf, CreateAmenityOption } from '../../models/calendar.model';
import { AmenityService } from '../../services/amenity.service';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-select-amenity-modal',
  templateUrl: './select-amenity-modal.component.html',
  styleUrl: './select-amenity-modal.component.scss'
})
export class SelectAmenityModalComponent implements OnInit {

  @Input() neighborhoodId: string = '';

  public amenityOptions: CreateAmenityOption[] = [];
  public loading: boolean = true;
  public skeletonKeys: string[] = [
    'skeleton-1',
    'skeleton-2',
    'skeleton-3',
    'skeleton-4',
    'skeleton-5',
    'skeleton-6'
  ];

  constructor(
    public activeModal: NgbActiveModal,
    public amenityService: AmenityService
  ) {

  }

  async ngOnInit(): Promise<void> {

    this.loading = true;

    await this.amenityService.getAll(
      this.neighborhoodId
    );

    this.amenityOptions = this.amenityService.amenities.map(
      amenity => ({
        amenity: amenity,
        color: amenityColorOf(amenity.amenityId)
      })
    );

    this.loading = false;
  }

  select(amenity: Amenity): void {

    if (!amenity.status) {
      return;
    }

    this.activeModal.close(amenity);
  }

}
